import { Search, X } from "lucide-react";
import { useCategories } from "@/contexts/CategoriesContext";

const LABEL = "font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-1";
const FIELD = "w-full bg-transparent border-b border-[#1A1F16] py-2 focus:outline-none";

/** Search / category / account / date-range bar for the Transactions page. */
export function TransactionFilters({ flt, onChange, accounts, hasFilter, onClear }) {
  const { income, expense, transfer, investment } = useCategories();
  const allCategories = [...new Set([...expense, ...income, ...transfer, ...investment])];
  const set = (patch) => onChange({ ...flt, ...patch });
  return (
    <div className="border border-[#D8D4C7] bg-white p-4 grid grid-cols-1 md:grid-cols-6 gap-4">
      <label className="block md:col-span-2 relative">
        <span className={LABEL}>Search</span>
        <div className="flex items-center border-b border-[#1A1F16]">
          <Search className="w-4 h-4 text-[#6C7565]" />
          <input
            value={flt.q}
            onChange={(e) => set({ q: e.target.value })}
            data-testid="txn-search-input"
            className="w-full bg-transparent py-2 px-2 focus:outline-none"
            placeholder="Search description or category…"
          />
          {flt.q && <button onClick={() => set({ q: "" })}><X className="w-4 h-4 text-[#6C7565]" /></button>}
        </div>
      </label>
      <label className="block">
        <span className={LABEL}>Category</span>
        <select value={flt.cat} onChange={(e) => set({ cat: e.target.value })} data-testid="txn-filter-category" className={FIELD}>
          <option value="">All categories</option>
          {allCategories.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </label>
      <label className="block">
        <span className={LABEL}>Account</span>
        <select value={flt.account} onChange={(e) => set({ account: e.target.value })} data-testid="txn-filter-account" className={FIELD}>
          <option value="">All accounts</option>
          {accounts.length === 0 && <option value="" disabled>No accounts yet — add one on the Accounts page</option>}
          {accounts.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
      </label>
      <label className="block">
        <span className={LABEL}>From</span>
        <input type="date" value={flt.start} onChange={(e) => set({ start: e.target.value })} data-testid="txn-start-date" className={FIELD} />
      </label>
      <label className="block">
        <span className={LABEL}>To</span>
        <input type="date" value={flt.end} onChange={(e) => set({ end: e.target.value })} data-testid="txn-end-date" className={FIELD} />
      </label>
      {hasFilter && (
        <button
          data-testid="txn-clear-filters"
          onClick={onClear}
          className="md:col-span-6 text-[10px] uppercase tracking-widest text-[#6C7565] hover:text-[#D94F3D] justify-self-end"
        >Clear filters ×</button>
      )}
    </div>
  );
}
